import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ReqService } from '@core/services/req.service';
import { SearchStateService } from '@core/services/search-state.service';
import { MbBreadcrumbs, MbBreadcrumbItem } from '@am/moebius';

@Component({
    selector: 'breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: true,
    imports: [MbBreadcrumbs, MbBreadcrumbItem],
})
export class BreadCrumbComponent implements OnChanges, OnInit {
  @Input()
  entity: any;
  @Input()
  hotelName: string;
  @Input()
  asyncBusy: boolean;
  @Input()
  busy: boolean;
  @Input()
  searchedEntity: any;

  public brand: string;
  public isBra: boolean;
  public isExpert: boolean;

  constructor(
    private searchStateService: SearchStateService,
    private reqService: ReqService,
  ) {}

  ngOnInit(): void {
    this.isBra = this.reqService.isBra();
    this.isExpert = this.reqService.isExperts();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['asyncBusy'] && changes['asyncBusy'].currentValue) {
      this.entity = this.searchStateService.getEntityName();
    }
    for (const key in changes) {
      if (!changes[key].isFirstChange() && changes.hasOwnProperty(key)) {
        this[key] = changes[key].currentValue;
      }
    }
  }

  public hotelLink() {
    if (this.isBra) {
      window.open('/hoteis', '_self');
    } else {
      window.open('/hoteles', '_self');
    }
  }

  public cityLink() {
    const slug = this.entity.name.replace(' ', '-') + '-' + this.entity.id;
    this.searchStateService.setSection('results');
    this.searchStateService.setType(this.entity.type);
    this.searchStateService.setSlug(slug);
    this.searchStateService.redirect();
  }
}
